import Button from "@material-ui/core/Button";
import CheckIcon from "@mui/icons-material/Check";
import React, { Component } from "react";

export class CreateButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
      type: props.type,
      pageId: props.pageId,
      isHovered: false,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <>
        {this.props.disabled ? (
          <Button
            type={this.state.type ? this.state.type : ""}
            disabled
            variant="contained"
            style={{
              background: "green",
              color: "#fff",
              marginRight: "1rem",
              fontWeight: "bold",
              textTransform: "capitalize",
              padding:
                this.state.pageId === "Message" ? "4px 12px" : "2px 10px",
            }}
            startIcon={<CheckIcon style={{ fontSize: "16px" }} />}
            onClick={this.onClick.bind(this)}
          >
            Save
          </Button>
        ) : (
          <Button
            type={this.state.type ? this.state.type : ""}
            variant="contained"
            style={{
              background: this.state.isHovered ? "#006600" : "green",
              color: "#fff",
              marginRight: "1rem",
              fontWeight: "bold",
              textTransform: "capitalize",
              padding:
                this.state.pageId === "Message" ? "4px 12px" : "2px 10px",
            }}
            startIcon={<CheckIcon style={{ fontSize: "16px" }} />}
            onClick={this.onClick.bind(this)}
            onMouseEnter={() => this.setState({ isHovered: true })}
            onMouseLeave={() => this.setState({ isHovered: false })}
          >
            Save
          </Button>
        )}
      </>
    );
  }
}
export default CreateButton;
